import { call, put, delay, takeLatest } from "redux-saga/effects";
import PrestadorActions, {
  Types as PrestadorTypes
} from "../../stores/prestador/Actions";
import PrestadorService from "../../services/prestador/PrestadorService";
import ResponseCode from "../../services/ResponseCode";

function* getProcedimientosPss(request) {
  yield put(PrestadorActions.getProcedimientosPssLoading());

  if (request.payload?.applyFilter) {
    yield delay(500);
  }

  const procedimientosResponse = yield call(
    PrestadorService.consultarProcedimientosPss,
    request.payload
  );

  if (
    !procedimientosResponse?.respuesta ||
    procedimientosResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrestadorActions.getProcedimientosPssFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (procedimientosResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      PrestadorActions.getProcedimientosPssFailure(
        procedimientosResponse?.respuesta
      )
    );
    return;
  }

  const { procedimientos } = procedimientosResponse?.data;

  const coberturas = procedimientos
    ?.map((procedimiento) => {
      return {
        ...procedimiento,
        nombreCobertura: procedimiento.nombreCobertura
      };
    })
    ?.sort((a, b) => a.cobertura - b.cobertura);

  yield put(
    PrestadorActions.getProcedimientosPssSuccess({
      coberturas,
      paginacion: procedimientosResponse?.paginacion
    })
  );
}

function* getMedicos(request) {
  yield put(PrestadorActions.getMedicosLoading());

  yield delay(500);

  const medicosResponse = yield call(
    PrestadorService.getMedicos,
    request.payload
  );

  const medicos = medicosResponse?.map((medico) => {
    return {
      key: medico.codigoMedico + medico.nombreMedico,
      codigo: medico.codigoMedico ? String(medico.codigoMedico) : "0",
      descripcion: medico.nombreMedico
    };
  });

  yield put(PrestadorActions.getMedicosSuccess({ medicos }));
}

function* actualizarPrestadorStandVirtual(request) {
  yield put(PrestadorActions.actualizarPrestadorStandVirtualLoading());

  const response = yield call(
    PrestadorService.actualizarPrestadorStandVirtual,
    request.payload
  );

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrestadorActions.actualizarPrestadorStandVirtualFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (response?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      PrestadorActions.actualizarPrestadorStandVirtualFailure(
        response?.respuesta
      )
    );
    return;
  }
  yield put(
    PrestadorActions.actualizarPrestadorStandVirtualSuccess({
      prestador: response?.data
    })
  );
}

const exportedArray = [
  takeLatest(PrestadorTypes.GET_PROCEDIMIENTOS_PSS, getProcedimientosPss),
  takeLatest(PrestadorTypes.GET_MEDICOS, getMedicos),
  takeLatest(
    PrestadorTypes.ACTUALIZAR_PRESTADOR_STAND_VIRTUAL,
    actualizarPrestadorStandVirtual
  )
];

export default exportedArray;
